module.exports = __webpack_public_path__ + "static/whentostoptesting@2x-66030ebcfad96599c110fe20b9971483.jpg";